<template>
  <div class="faq-page">
    <b-card
      no-body
      class="faq-wrapper-card"
    >
      <b-card-body class="faq-wrapper-body">
        <div class="faq-header text-center">
          <h2 class="faq-title">
            FAQ's
          </h2>
          <p class="faq-subtitle">
            Let us help answer the most common questions.
          </p>
          <b-form-input
            v-model="search"
            placeholder="Search FAQs..."
            class="faq-search mt-1"
          />
        </div>

        <div
          v-if="isLoading"
          class="faq-loader"
        >
          <b-spinner label="Loading..." />
        </div>

        <div
          v-else-if="!displayFaqs.length"
          class="faq-empty text-center text-muted py-2"
        >
          {{ faqEmptyText }}
        </div>

        <div
          v-else
          class="faq-list"
        >
          <div
            v-for="(item, index) in displayFaqs"
            :key="item.id || `${item.question}-${index}`"
            class="faq-item"
          >
            <button
              type="button"
              class="faq-question"
              @click="toggleFaq(index)"
            >
              <span>{{ item.question }}</span>
              <feather-icon
                :icon="openIndex === index ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                size="16"
                class="faq-chevron"
              />
            </button>

            <b-collapse :visible="openIndex === index">
              <div class="faq-answer">
                {{ item.answer }}
              </div>
            </b-collapse>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCollapse,
  BSpinner,
  BFormInput,
} from 'bootstrap-vue'
import { vendorPanelApi } from '@/services/vendorPanelApi'

export default {
  components: {
    BCard,
    BCardBody,
    BCollapse,
    BSpinner,
    BFormInput,
  },
  data() {
    return {
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      isLoading: false,
      faqs: [],
      search: '',
      openIndex: 0,
      loadingTimeoutId: null,
    }
  },
  computed: {
    displayFaqs() {
      const term = this.search.trim().toLowerCase()
      const source = Array.isArray(this.faqs) ? this.faqs : []
      if (!source.length) {
        return []
      }
      if (!term) {
        return source.slice(0, 10)
      }
      return source.filter(item => `${item.question} ${item.answer}`.toLowerCase().includes(term))
    },
    faqEmptyText() {
      if (this.search.trim()) {
        return 'No FAQs match your search.'
      }
      return 'No FAQs available yet.'
    },
  },
  mounted() {
    this.getFaqs()
  },
  beforeDestroy() {
    if (this.loadingTimeoutId) {
      clearTimeout(this.loadingTimeoutId)
      this.loadingTimeoutId = null
    }
  },
  methods: {
    toggleFaq(index) {
      this.openIndex = this.openIndex === index ? -1 : index
    },
    async getFaqs() {
      this.isLoading = true

      if (this.loadingTimeoutId) {
        clearTimeout(this.loadingTimeoutId)
      }
      this.loadingTimeoutId = setTimeout(() => {
        this.isLoading = false
      }, 15000)

      if (!this.accessToken || !this.baseApi) {
        this.faqs = []
        this.isLoading = false
        clearTimeout(this.loadingTimeoutId)
        this.loadingTimeoutId = null
        return
      }

      try {
        const response = await vendorPanelApi.faq()
        const content = response?.data?.data?.content

        if (Array.isArray(content)) {
          this.faqs = content
            .map((item, index) => ({
              id: `faq-${index}`,
              question: item?.question || 'FAQ',
              answer: item?.answer || '',
            }))
            .filter(item => item.question || item.answer)
        } else {
          this.faqs = []
        }
      } catch (e) {
        this.faqs = []
      } finally {
        this.isLoading = false
        clearTimeout(this.loadingTimeoutId)
        this.loadingTimeoutId = null
      }
    },
  },
}
</script>

<style scoped lang="scss">
.faq-wrapper-card {
  border: 1px solid #ececf3;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(39, 44, 62, 0.05);
}

.faq-wrapper-body {
  padding: 1.8rem 1rem 2.1rem;

  @media (min-width: 992px) {
    padding: 3rem 3.4rem 3.2rem;
  }
}

.faq-header {
  margin-bottom: 1.7rem;
}

.faq-title {
  font-size: 2.6rem;
  font-weight: 700;
  color: #4b465c;
  margin-bottom: 0.3rem;
}

.faq-subtitle {
  font-size: 1rem;
  color: #88839b;
  margin-bottom: 0;
}

.faq-search {
  max-width: 420px;
  margin: 0 auto;
}

.faq-loader {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq-list {
  max-width: 940px;
  margin: 0 auto;
}

.faq-item {
  border: 1px solid #ececf3;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(39, 44, 62, 0.05);
  margin-bottom: 0.5rem;
  overflow: hidden;
}

.faq-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: #fff;
  padding: 0.88rem 0.9rem;
  text-align: left;
  font-size: 1rem;
  color: #4b465c;
  font-weight: 500;
}

.faq-chevron {
  color: #8f8aa3;
  margin-left: 0.6rem;
  flex-shrink: 0;
}

.faq-answer {
  border-top: 1px solid #f0eff5;
  padding: 0.85rem 0.9rem;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #6f6b86;
  background: #fff;
}
</style>
